import React from 'react';

import { Hidden, Icon, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { LinkNoDecoration } from 'components/app-header/styled';
import { LoyaltyPointsButton } from 'components/loyalty-points-button';
import { useEnableSignUpSignInABTest } from 'pages/authentication/use-enable-sign-up-sign-in-a-b-test';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

const MobileHeaderCta = () => {
  const enableSignUpSignInABTest = useEnableSignUpSignInABTest();
  const { formatMessage } = useIntl();

  const enableSignUp = useFlag(LaunchDarklyFlag.ENABLE_SIGN_UP);
  const enableAccountInFooter = useFlag(LaunchDarklyFlag.ENABLE_ACCOUNT_IN_FOOTER);
  const isHamburgerMenuEnabled = useFlag(LaunchDarklyFlag.ENABLE_HAMBURGER_MENU_ON_MOBILE);
  const enableLoyaltyPointsInHeader = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_POINTS_IN_HEADER);
  const { isAuthenticated } = useAuthContext();

  if (isAuthenticated) {
    return (
      <>
        <LoyaltyPointsButton />
        {!enableAccountInFooter && !isHamburgerMenuEnabled && (
          <LinkNoDecoration testID="mobile-nav-account-link" to={routes.account}>
            <Icon variant="account" height={6} width={8} aria-hidden />
            <Hidden>
              <Text>{formatMessage({ id: 'account' })}</Text>
            </Hidden>
          </LinkNoDecoration>
        )}
      </>
    );
  }

  if (!enableSignUp) {
    return null;
  }

  return (
    <ActionButton
      variant={
        enableLoyaltyPointsInHeader && !enableSignUpSignInABTest
          ? ActionButtonVariants.OUTLINE
          : ActionButtonVariants.PRIMARY
      }
      size={ActionButtonSizes.SMALL}
      to={enableSignUpSignInABTest ? routes.signIn : routes.signUp}
      testID="mobile-nav-signup-link"
      alignSelf="center"
    >
      {formatMessage({ id: enableSignUpSignInABTest ? 'signInUp' : 'signUp' })}
    </ActionButton>
  );
};

export default MobileHeaderCta;
